import { arrayOf, objectOf, maybe } from "@altostra/type-validations";
import { boolean, number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementGeofencesDataResult = arrayOf(
  objectOf({
    id: string,
    ls_id: string,
    name: string,
    lat: number,
    lng: number,
    radius: number,
    cooldown_enter: maybe(number),
    cooldown_exit: maybe(number),
    analytics_enabled_enter: maybe(boolean),
    analytics_enabled_exit: maybe(boolean),
    notification_responsiveness: maybe(number),
  })
);
